import classNames from "classnames";
import React, { FunctionComponent } from "react";
import { DetailedCartItem } from "../../../../../../../../../context/CartContext/CartContext.api.types";
import { displayMoney } from "../../../../../../../../../utils/displayMoney";
import { displayWeight } from "../../../../../../../../../utils/displayWeight";
import setColorName from "../../../../../../../../../utils/setColorName";

import "./MainDetail.scss";

type Props = {
  cartDetailedItem: DetailedCartItem;
  labels: LenghtLabel;
};

const COLOR_ICON_MODIFIER_BY_VARIATION: Record<string, string> = {
  amarillo: "gold",
  rojo: "red",
  blanco: "white",
  plata: "silver",
  soaked: "soaked",
  rose: "rose",
  golden: "golden",
};

const MainDetail: FunctionComponent<Props> = ({ cartDetailedItem, labels }) => {
  const variationColor = cartDetailedItem.variation.color;
  const colorName = setColorName(variationColor);
  const mobileColorName = variationColor === "soaked" ? "empav" : colorName;
  const colorIconModifier = COLOR_ICON_MODIFIER_BY_VARIATION[variationColor];

  return (
    <main className="main-detail">
      <span className="main-detail__header">Color</span>
      <span className="main-detail__header">{labels.cartGaugeLabel}</span>
      <span className="main-detail__header">{labels.cartLenghtLabel}</span>
      <span className="main-detail__header">Peso</span>
      <span className="main-detail__header">Hechura</span>
      <div className="main-detail__color">
        <span
          className={classNames("main-detail__color__icon", {
            [`main-detail__color__icon--${colorIconModifier}`]:
              !!colorIconModifier,
          })}
        />
        <span>{mobileColorName}</span>
      </div>
      <span className="main-detail__description">
        {cartDetailedItem.variation.gauge}
      </span>
      <span className="main-detail__description">
        {cartDetailedItem.variation.length} {labels.unit}
      </span>
      <span className="main-detail__description">
        {displayWeight(cartDetailedItem.variation.weight.replace(",", "."))}
      </span>
      <span className="main-detail__description">
        {cartDetailedItem.manufacturingCost == 0
          ? "Consultar"
          : displayMoney(cartDetailedItem.manufacturingCost)}
      </span>
    </main>
  );
};

export default MainDetail;
